import { IConfigsType } from '../../types'

const demo: IConfigsType = {
  'wingitnorth-demo-page-b7281beb': {
    '/:brand/demo': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'wingitnorth/demo',
      },
    },
  },
}

export default demo
